import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32de1aad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_2 = {
  key: 3,
  class: "control-text"
}

import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlButton',
  props: {
  icon: {
    type: String,
    default: 'cam',
  },
  iconDisabled: {
    type: String,
    default: undefined,
  },
  height: {
    type: String,
    default: '24',
  },
  name: {
    type: String,
    default: '',
  },
  badge: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isReady: {
    type: Boolean,
    default: true,
  },
  isDangerDisabled: {
    type: Boolean,
    default: false,
  },
  isWarning: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const customCss = computed(() => {
  return {
    '-enabled': !props.disabled,
    '-disabled': props.disabled,
    '-red': props.disabled && props.isDangerDisabled,
    '-not-ready': !props.isReady,
  }
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control-item _pointer-on-hover _prevent-text-select", customCss.value])
  }, [
    (__props.isWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SvgIcon, {
            class: "control-icon",
            icon: "warning",
            "inherit-fill": true,
            width: "10",
            height: "10"
          })
        ]))
      : _createCommentVNode("", true),
    (__props.disabled && __props.iconDisabled)
      ? (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 1,
          class: "control-icon",
          icon: __props.iconDisabled,
          "inherit-fill": true,
          height: __props.height
        }, null, 8, ["icon", "height"]))
      : _createCommentVNode("", true),
    (!__props.disabled || !__props.iconDisabled)
      ? (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 2,
          class: "control-icon",
          icon: __props.icon,
          "inherit-fill": true,
          height: __props.height
        }, null, 8, ["icon", "height"]))
      : _createCommentVNode("", true),
    (__props.name)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.name), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", { class: "badge" }, _toDisplayString(__props.badge), 513), [
      [_vShow, !!__props.badge]
    ])
  ], 2))
}
}

})